/**
 * Represents the user type - "I'm a [UserType]".
 */
export enum UserType {
  Breeder = 0,
  Buyer = 1,
  ServiceProvider = 2
}
